import React, {memo, useContext} from 'react';
import './OrderInfo.less';
import {ListSplitter} from "elements/list-splitter/ListSplitter.tsx";
import {InfoItem} from "compositions/info-item/InfoItem";
import {InfoItemValue} from "elements/info-item-value/InfoItemValue";
import {OrderStatusBadge} from "compositions/order-status-badge/OrderStatusBadge";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const OrderInfo = memo(({status, readyTime, isPaid, paymentType, address, orderId, placedAt}) => {
	const translations = useContext(TranslationsContext);

	return <ul className="order-info">
		<li className="order-info__item" key="status">
			<InfoItem label={getSafeTranslation('OrderInfo.statusLabel', translations)} control={
				<OrderStatusBadge orderStatus={status}/>
			}/>
		</li>
		<ListSplitter key="splitter-1"/>
		<li className="order-info__item" key="ready-time">
			<InfoItem label={getSafeTranslation('OrderInfo.readyTimeLabel', translations)} control={
				<InfoItemValue text={readyTime}/>
			}/>
		</li>
		<ListSplitter key="splitter-2"/>
		<li className="order-info__item" key="payment-type">
			<InfoItem
				label={
					isPaid
						? getSafeTranslation('OrderInfo.paidLabel', translations)
						: getSafeTranslation('OrderInfo.notPaidLabel', translations)
				}
				control={
					<InfoItemValue text={paymentType}/>
				}
			/>
		</li>
		<ListSplitter key="splitter-3"/>
		<li className="order-info__item" key="address">
			<InfoItem label={
				getSafeTranslation('OrderInfo.pickUpPlaceLabel', translations)
			} control={
				<InfoItemValue text={address} isBold/>
			}/>
		</li>
		<ListSplitter key="splitter-4"/>
		<li className="order-info__item" key="order-id">
			<InfoItem label={getSafeTranslation('OrderInfo.orderIdLabel', translations)} control={
				<InfoItemValue text={orderId}/>
			}/>
		</li>
		{
			placedAt && (<ListSplitter key="splitter-5"/>)
		}
		{
			placedAt && (<li className="order-info__item" key="placed-at">
				<InfoItem label={getSafeTranslation('OrderInfo.placedAtLabel', translations)} control={
					<InfoItemValue text={`${placedAt.time} ${placedAt.date}`}/>
				}/>
			</li>)
		}

	</ul>
})
